const principles = [
  {
    icon: 'ri-layout-masonry-line',
    title: 'Clean Architecture',
    description: 'Systems are designed with clear separation of concerns, ensuring each component has a well-defined role and responsibility. This approach enables maintainable codebases that can evolve gracefully over time without accumulating technical debt.',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Performance Optimization',
    description: 'Every aspect of system performance is carefully measured and optimized. From rendering pipelines to data access patterns, the team ensures software runs efficiently under real-world conditions and delivers responsive experiences.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'User-Centered Design',
    description: 'Design decisions are grounded in an understanding of how people interact with software. Interfaces are crafted for clarity, accessibility, and intuitive workflows that reduce cognitive load and enhance productivity.',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Scalable & Maintainable',
    description: 'Solutions are built to grow. Architectural decisions account for future expansion, team scaling, and evolving requirements. Codebases remain structured, documented, and testable throughout their lifecycle.',
  },
  {
    icon: 'ri-loop-right-line',
    title: 'Continuous Innovation',
    description: 'The team stays at the forefront of software engineering by continuously exploring emerging technologies, refining development workflows, and integrating proven innovations into daily practice.',
  },
  {
    icon: 'ri-award-line',
    title: 'Engineering Standards',
    description: 'Up-to-date industry standards guide every aspect of development. From version control practices to deployment strategies, the company maintains rigorous quality benchmarks across all projects.',
  },
];

export default function PrinciplesSection() {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16 md:mb-20">
          <p className="font-label text-sm tracking-widest uppercase text-secondary-600 mb-4">Principles</p>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 leading-tight max-w-2xl mx-auto">
            Built on a foundation of engineering excellence
          </h2>
          <div className="w-12 h-px bg-primary-400 mx-auto mt-6"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {principles.map((item) => (
            <div
              key={item.title}
              className="group p-8 bg-background-50 rounded-lg border border-background-200/60"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 mb-6">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-xl text-foreground-900 mb-3">{item.title}</h3>
              <p className="font-body text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}